import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton } from "react-bootstrap";
import { useState, useEffect} from "react";
import ListUserTable from "Containers/Private/User/List/ListUserTable";
import {useLocation } from 'react-router-dom';
import { STATUSES } from "Utils/constants";
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {GetUserTextInputData, GetUserCheckboxInputData, GetUserDateInputData, GetUserPhoneInputData, GetUserSelectInputData, GetUserRadioInputData } from 'Containers/Private/Organization/Data files/UserFields';
import {GetTextInputData, GetCheckboxInputData, GetDateInputData, GetPhoneInputData, GetSelectInputData, GetRadioInputData, GetSelectInputObj } from 'Containers/Private/Organization/Data files/OrganizationFields';
import {ACTIONS,formInfoReducer} from 'Containers/Private/Organization/OrganizationFormDataReducer'
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import {Link, useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { getOrganizationList } from "Utils/utilityFunctions";
import {OrgList} from "Components/OrgList/OrgList";
import ListTableauUsersTable from "./ListTableauUsersTable";
import ListTableauReportDefinitionsTable from "./ListTableauReportDefinitionsTable";

const ManageTableau = () => {
    const navigate = useNavigate();

    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    const [dataSubTab, setDataSubTab] = useState("report");

    //const [isLoading, setIsLoading] = useState(true)

    var dispatch = useDispatch();

    const loginState = store.getState().loginInfo;

    useEffect(()=> {
        if(passedData!=null && passedData.hasOwnProperty("tab")){
            setDataSubTab(passedData.tab);
        }
    },[])
    

    


    const handleDataSubTabChange = (e) => {
        setDataSubTab(e);
    }

    return (
        //isLoading==false 
        // ?
        <Row>
            <Row >
                    <Col xl={11} lg={11} md={12} sm={12}>
                        
                        <Card className="p-4" >
                            <Card.Body className="text-start">
                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Manage Interactive Reports</h1>
                                </Row>
                                <Row>
                                    <Row>
                                        <Col>
                                            <Tabs
                                                id="dataSubTabs"
                                                activeKey={dataSubTab}
                                                onSelect={(k) => handleDataSubTabChange(k)}
                                                //fill={false}
                                                //justify={true}
                                                //className="d-flex"
                                                mountOnEnter={true}
                                                unmountOnExit={true}
                                            >
                                                <Tab eventKey="report" title="Interactive Reports">
                                                    <ListTableauReportDefinitionsTable></ListTableauReportDefinitionsTable>
                                                </Tab>
                                                <Tab eventKey="user" title="Interactive Report Users" >
                                                    <ListTableauUsersTable/>
                                                </Tab>
                                                
                                            </Tabs>
                                        </Col>
                                    </Row>
                                </Row>
                                    
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            
            </Row>
        //: null    
    )
}

export default ManageTableau;